export const validator = {
  email_error_invalid: "Invalid email address",

  pw_error:
    "Use at least 8 characters and at least one of each: uppercase, lowercase, number",
};
